export default __webpack_public_path__ + "static/media/logo.e080099e.png";